import EMVERSITY from "@/assets/industry-co-led/partners/NEPHROPLUS.png";
import Icon1 from "@/assets/industry-co-led/logo/madel.png";
import Icon2 from "@/assets/industry-co-led/logo/network.png";

import Student1 from "@/assets/students/student1.png";
import Student2 from "@/assets/students/student2.png";
import Student3 from "@/assets/students/student3.png";
import Student4 from "@/assets/students/student4.png";

const OJLImg1 ="https://cdn.msu.edu.in/medium_msu_emergency_medical_tech1_f3261b53d1.webp";
const OJLImg2 = "https://cdn.msu.edu.in/medium_msu_emergency_medical_tech3_596a3c4319.webp";
const OJLImg3 = "https://cdn.msu.edu.in/medium_msu_emergency_medical_tech4_509a1d5471.webp";
const OJLImg4 = "https://cdn.msu.edu.in/medium_msu_emergency_medical_tech2_d2775e1654.webp";
const OJLImg5 = "https://cdn.msu.edu.in/medium_msu_emergency_medical_tech6_b923c3ee90.webp";
const OJLImg6 = "https://cdn.msu.edu.in/medium_msu_emergency_medical_tech5_16b83ba5e8.webp";

const Img1 = "https://cdn.msu.edu.in/Radiology_1_fd63892112.webp";
const Img2 = "https://cdn.msu.edu.in/dialysis_3_802e00fc5b.jpg";
const Img3 = "https://cdn.msu.edu.in/R_4_20cfa25db5.webp";
const Img4 = "https://cdn.msu.edu.in/R_3_bb8d3983be.webp";
const Img5 = "https://img.youtube.com/vi/lTWke3-IGz4/hqdefault.jpg";

export const diplomaDTT = {

    heroSection: {
        breadcrumb: [
            { name: "Home", url: "/" },
            { name: "Industry Co-led UG Programmes", url: "/industry-co-led-ug-programmes" },
            { name: "Diploma in Dialysis Technology", url: "" }
        ],

        bannerImg: '/assets/industry-co-led-banner.png',

        title: "Diploma in Dialysis Technology",

        poweredBy: {
            text: "Industry Skilling Partner",
            logo: EMVERSITY
        },

        duration: "2.5 Year Undergraduate Programme",

        description:
            "Learn about Human Anatomy and Physiology, General Biochemistry, Biomedical Waste Management and more.",

        stats: [
            {
                value: "Up to 70%",
                label: "Practical Curriculum"
            },
            {
                value: "Paid",
                label: "On-the-job learning"
            },
            {
                value: "100%",
                label: "Placement Assistance"
            }
        ],

        buttons: {
            enroll: "Enroll Now"
        },

        video: {
            thumbnail: 'https://img.youtube.com/vi/bmOZjMrnwkc/hqdefault.jpg',
            buttonText: "Watch Programme Video",
            url: "https://www.youtube.com/embed/bmOZjMrnwkc"
        }
    },

    aboutSection: {
        tag: "ABOUT THE PROGRAMME",

        title: "Undergraduate Healthcare Programme in Dialysis Technology",

        description: [
            "The Diploma in Dialysis Technology is designed to provide students with comprehensive knowledge of renal care, dialysis procedures and patient management practices. The programme equips learners with the technical and clinical skills required to operate dialysis equipment, assist in haemodialysis procedures, monitor patient response and support infection control and emergency care protocols within renal healthcare settings.",

            "Structured with a blend of academic learning, laboratory practicals and extensive clinical exposure, the programme prepares students for real-world healthcare environments through hands-on training in dialysis technology and patient-care practices. Suitable for students seeking a career in allied and paramedical healthcare after higher secondary education, the programme opens opportunities across hospitals, dialysis units, nephrology departments, ICUs and specialised renal care centres."
        ],

        stats: [
            {
                value: "Up to 70%",
                label: "Practical Curriculum"
            },
            {
                value: "Paid",
                label: "On-the-job learning"
            },
            {
                value: "100%",
                label: "Placement Assistance"
            }
        ],

        approvals: [
            "UGC Approved",
            "NEP 2020 Aligned",
            "Govt. Scholarships Available"
        ],

        journeyTitle: "Your 2.5 Year Journey",

        journey: [
            {
                phase: "YEAR 1",
                title: "Foundations in Healthcare & Renal Sciences",
                description: "Learn Human Anatomy, Physiology, Microbiology, Biochemistry, Kidney Diseases and Basics of Dialysis through theory, practicals and clinical exposure"
            },
            {
                phase: "YEAR 2",
                title: "Clinical Dialysis Training & Patient Care",
                description: "Develop skills in Dialysis Procedures, Dialysis Instrumentation, Pharmacology, Renal Nutrition, Nursing Care and Basic Life Support through hands-on training"
            },
            {
                phase: "FINAL PHASE",
                title: "Internship & Advanced Clinical Practice",
                description: "Gain real-world experience through compulsory rotatory internship and supervised clinical practice in dialysis and renal care settings"
            },
            {
                phase: "GRADUATE",
                title: "Diploma in Dialysis Technology",
                description: "Industry-ready allied healthcare professional"
            }
        ]
    },

    offeringSection: {
        tag: "OUR OFFERING",

        title: {
            first: "Comprehensive",
            highlight: "Allied Healthcare Education"
        },

        description:
            "We offer a UGC-approved, 2.5-year full-time undergraduate degree of Diploma in Dialysis Technology at Medhavi Skills University, Sikkim. It is an industry-aligned healthcare degree designed to build strong paramedical skills and prepare students for diverse roles.",

        learningBox: {
            title: "Key Areas of Learning",

            points: [
                "Human Anatomy & Physiology",
                "Basics of Pharmacology",
                "Kidney Diseases & Renal Care",
                "Dialysis Procedures & Instrumentation",
                "Basic Life Support & Nursing Care",
                "Medical Ethics, Communication & Patient Management"
            ]
        },

        image: 'https://cdn.msu.edu.in/R_5_21755354c6_88104dbb69.webp'
    },

    whyEMT: {
        tag: "WHY DIALYSIS THERAPY TECHNOLOGY. WHY NOW.",

        title: "Building Skilled Allied Healthcare Professionals for Modern Clinical Care",

        description:
            "The Diploma in Dialysis Technology equips learners with clinical knowledge, technical expertise and hands-on patient-care skills required to support dialysis procedures, renal care services and critical healthcare operations across hospitals, dialysis centres and intensive care settings.",

        stats: [
            {
                value: "60%",
                text: "of the healthcare workforce consists of allied healthcare professionals, highlighting their critical role in patient care and clinical services across hospitals and healthcare systems",
            },
            {
                value: "8 million+",
                text: "is the estimated shortage of allied healthcare professionals and nurses in India, creating strong demand for skilled clinical support professionals",
            },
            {
                value: "1 lakh allied health professionals",
                text: "are planned to be added by the Government of India over the next five years to strengthen healthcare delivery and workforce capacity",
            },
        ],
    },

    msuAdvantages: {
        tag: "MSU ADVANTAGES",

        title: "Programme by NephroPlus, Delivered at MSU Campus",

        description:
            "Your edge at Medhavi Skills University, where real-world learning, industry exposure and future-ready skills come together.",

        cards: [
            {
                number: "01",
                text: "Only university in Sikkim aligned with paid On-the-Job Learning embedded curriculum for practical learning",
            },
            {
                number: "02",
                text: "Only university in Sikkim to ensure 100% of our student applicants receive government scholarships",
            },
            {
                number: "03",
                text: "Well-equipped healthcare labs, advanced training setups and hands-on field training",
            },
        ],

        pointerTitle: "Highlights from The Programme:",

        highlights: [
            "Programme aligned with NEP 2020, focused on Learning Outcome Based Education",
            "Up to 70% practical based curriculum",
            "Paid On-the-Job Learning (OJL)",
            "Industry-aligned curriculum & hands-on learning",
            "Learn from seasoned healthcare professionals",
            "Immersive industry exposure through industry visits, guest lectures and networking opportunities",
            "Opportunity to 'learn and earn' through immersive on-the-job learning, industry projects and internships with leading companies",
            "Engage with industry experts to get invaluable insights and real-world perspectives",
            "Programme is NCAHP aligned"
        ],

        image: 'https://cdn.msu.edu.in/advantages_e4b02487af_91b7edc1da.webp',
    },

    CTA: {
        title: "Start Your Journey in Allied Healthcare with Nephroplus's",
        highlights: "Diploma in Dialysis Technology",
        url: "#",
        btnName: "Apply Now"
    },

    onJobTrainingData: {
        tag: "Hands-On Experience",

        title: "On-the-Job Learning",

        description:
            "At Medhavi Skills University, On-the-Job Learning (OJL) enables students to gain real industry experience and earn a stipend while they learn.",

        images: [
            { id: 1, src: OJLImg1, alt: "Medical training" },
            { id: 2, src: OJLImg2, alt: "Lab practice" },
            { id: 3, src: OJLImg3, alt: "Patient training" },
            { id: 4, src: OJLImg4, alt: "Lab testing" },
            { id: 5, src: OJLImg5, alt: "Computer lab work" },
            { id: 6, src: OJLImg6, alt: "Chemical lab testing" }
        ]
    },

    addtionSkill: {
        courseSections: {
            AdditionalSkills: {
                tag: "Bonus Credentials",

                title: "Additional Skills Certifications",

                description:
                    "At Medhavi Skills University, students have the opportunity to gain credible Skill Certifications like Basic Life Support (BLS), Basic Trauma Life Support (BTLS) and more. These certifications, earned alongside the degree, enhance credibility, strengthen industry relevance and prepare students for employment with nationally and globally recognised credentials.",

                image: {
                    url: 'https://cdn.msu.edu.in/small_RAH_6076_1_ecb8075310.jpg',
                    alternativeText: "Skill Certification"
                },

                items: [
                    {
                        id: 1,
                        text: "BLS, BTLS Certified",
                        icon: Icon1
                    },
                    {
                        id: 2,
                        text: "Nationally & Globally Recognised",
                        icon: Icon2
                    }
                ],

                button: {
                    text: "Apply Now",
                    link: "/apply"
                }
            }
        }
    },

    DoExperienceLearndata: {
        tag: "INFRASTRUCTURE",

        title: "Do-Experience-Learn",

        description:
            "Discover the advantage of MSU's cutting-edge infrastructure, featuring modern laboratories, classrooms, and industry-relevant facilities",

        images: [
            { id: 1, src: Img1, size: "large", alt: "Do-Experience-Learn-lab" },
            { id: 2, src: Img2, size: "large", alt: "Do-Experience-Learn-lab" },
            { id: 3, src: Img3, size: "small", alt: "Do-Experience-Learn-lab" },
            { id: 4, src: Img4, size: "small", alt: "Do-Experience-Learn-lab" },
            { id: 5, src: Img5, size: "small", alt: "Do-Experience-Learn-lab" },
        ],
    },

    studentStoriesData: {
        title: "Medhavians Speak",

        subText:
            "These stories reflect what happens when learning goes beyond theory. From hands-on training to real-world exposure, our students build skills that translate directly into careers.",

        students: [
            {
                name: "Radhika Chettri",
                image: Student2,
                videLink: "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-Long.mp4",
                shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-short.mp4"
            },
            {
                name: "Pratik Chettri",
                image: Student3,
                videLink: "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science-Long.mp4",
                shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science+-short.mp4"
            },
            {
                name: "Suhana Sharma",
                image: Student4,
                videLink: "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-Long.mp4",
                shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-short.mp4"
            },
            {
                name: "Hissey Bhutia",
                image: Student1,
                videLink: "https://cdn.msu.edu.in/Student-Testimonials/Nursing-Long.mp4",
                shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Nursing-short.mp4"
            },
        ],
    },

    eligibility: {
        tag: "ELIGIBILITY",

        title: "Eligibility",

        description: "10+2 (Science) with 50% Aggregate in PCB",

        button: {
            text: "Apply Now",
            url: ""
        },
    },

    careerProspects: {
        tag: "CAREER PROSPECTS",

        heading: "Career Prospects",

        description:
            "Join this allied healthcare programme and build a rewarding career in dialysis technology, renal care and clinical support services",

        roles: [
            "Dialysis Technician/Dialysis Technologist",
            "Clinical Dialysis Assistant",
            "Renal Care Technician",
            "Dialysis Unit Coordinator",
            "Patient Care Technician",
            "Critical Care Dialysis Assistant",
            "Haemodialysis Technician",
            "Dialysis Equipment Support Executive",
            "Clinical Support Staff – Nephrology Units",
            "Renal Nutrition Support Assistant",
            "Hospital Dialysis Department Executive",
            "Healthcare Operations Assistant",
            "Clinical Service Coordinator – Renal Care",
            "Entrepreneur – Dialysis & Patient Care Services"
        ]
    },

    curriculumStructure: {
        label: "What You Will Learn",

        heading: "Curriculum Structure",

        description:
            "Step into an industry-oriented learning environment designed to build clinical knowledge, practical skills and real-world readiness for careers in dialysis technology and allied healthcare services.",

        semesters: [
            {
                name: "Semester 1",

                title: "Building Foundations in Healthcare & Renal Sciences",

                description:
                    "This semester introduces students to the fundamentals of healthcare, human anatomy, physiology, microbiology and kidney diseases while developing communication, clinical awareness and foundational dialysis knowledge through theory, practicals and skill-based learning.",

                subjects: [
                    { name: "Introduction to Healthcare Delivery System in India", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Basic Computers, Communication & Soft Skills", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Human Anatomy & Physiology", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Basics of Microbiology, Biochemistry & Pathology", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Human Anatomy & Physiology Practicals", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Community Orientation & Clinical Visit", bgColor: "bg-[#E8D4FF]", textColor: "text-[#7B2CBF]" },
                    { name: "Skill Drill", bgColor: "bg-[#FFD4E5]", textColor: "text-[#C41E3A]" }
                ]
            },

            {
                name: "Semester 2",

                title: "Understanding Patient Care & Kidney Diseases",

                description:
                    "Students develop knowledge in pharmacology, medical ethics, professionalism and kidney diseases while gaining hands-on exposure to dialysis environments through clinical postings and practical training.",

                subjects: [
                    { name: "Medical Terminology, Record Keeping, Medical Law & Ethics", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Basics of Pharmacology", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Professionalism & Values", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Introduction to Kidney Diseases", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Clinical Postings I", bgColor: "bg-[#E8D4FF]", textColor: "text-[#7B2CBF]" },
                    { name: "Skill Drill", bgColor: "bg-[#FFD4E5]", textColor: "text-[#C41E3A]" }
                ]
            },

            {
                name: "Semester 3",

                title: "Developing Clinical Dialysis & Technical Skills",

                description:
                    "This semester focuses on dialysis procedures, dialysis instrumentation, patient monitoring and healthcare management supported by practical learning and advanced clinical exposure.",

                subjects: [
                    { name: "Principles & Practice of Dialysis – Part I", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Instruments Specific to Dialysis Therapy", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Principles of Management", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Pharmacology Related to Dialysis", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Principles & Practice of Dialysis Practicals", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Clinical Postings II", bgColor: "bg-[#E8D4FF]", textColor: "text-[#7B2CBF]" }
                ]
            },

            {
                name: "Semester 4",

                title: "Advancing Dialysis Procedures & Patient Care",

                description:
                    "Students strengthen their expertise in dialysis therapies, renal nutrition, nursing care and emergency response through applied practical training and supervised clinical practice.",

                subjects: [
                    { name: "Principles & Practice of Dialysis – Part II", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Basic Life Support (BLS)", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Renal Nutrition", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Basic Principles of Nursing Care", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Dialysis Practicals", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "BLS Practicals", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Clinical Postings III", bgColor: "bg-[#E8D4FF]", textColor: "text-[#7B2CBF]" }
                ]
            },

            {
                name: "Semester 5",

                title: "Internship & Real-World Clinical Exposure",

                description:
                    "The final phase provides immersive hospital-based learning through compulsory rotatory internship across dialysis units, nephrology departments and critical care settings.",

                subjects: [
                    { name: "Compulsory Rotatory Internship", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" }
                ]
            }
        ]
    },

    faq: {
        id: 102,

        title: "Find quick answers to the most common questions about our programme",

        FAQ: [
            {
                id: 1,
                Question: "What is the university’s role and what is Nephrocare’s role?",
                Answer: "MSU manages all academic matters — admissions, examinations, marksheets, transcripts, and degree conferral. All fees are payable directly to the university. Nephrocare is the industry-skilling partner and delivers training, industry-co-designed skill modules, clinical internship facilitation and placement assistance. Nephrocare does not collect fees, conduct exams or award degrees."
            },
            {
                id: 2,
                Question: "Is placement or internship stipend guaranteed?",
                Answer: "We provide 100% placement support through our network of 500+ healthcare employer partners and guarantee structured clinical internships as part of the programme. While placements are not guaranteed, students receive extensive career assistance and industry exposure. Internship stipend amounts may vary depending on the employer, and final hiring and stipend decisions rest with the host institution."
            },
            {
                id: 3,
                Question: "Is this program recognised, and is it full-time?",
                Answer: "Yes, this is a full-time, on-campus program. MSU is established under the Medhavi Skills University, Sikkim Act, 2021 and is recognised by the UGC under Section 2(f). The curriculum is aligned with the NCAHP Act 2021 framework. Students should verify current NCAHP notifications and state council registration requirements directly with the university."
            },
            {
                id: 4,
                Question: "How do I apply?",
                Answer: "Applications are submitted through MSU’s official admissions portal. Candidates may be required to appear for the Medhavi Scholarship & Aptitude Test (MSAT). For eligibility verification, fee details, and application deadlines, please contact the MSU admissions office directly."
            },
            {
                id: 5,
                Question: "What is the Head Start Programme?",
                Answer: "The Head Start Programme is a zero-cost, online bridge course offered before classes begin. It covers foundational concepts and essential skills for your chosen field. Participation is voluntary, non-credit-bearing, and does not affect admission status or academic standing. Students who successfully complete it receive a complimentary laptop and may be eligible for additional scholarships."
            },
            {
                id: 6,
                Question: "Is this programme NCAHP aligned?",
                Answer: "Yes. The curriculum is subject to periodic revision by MSU in alignment with NCAHP guidelines and evolving industry requirements. Students should refer to the university’s official academic notifications for the latest syllabus."
            }
        ]
    },

    coursePrice: {
        price: "₹2,25,000"
    }

};